import { ComboboxData } from "@mantine/core";
import { FieldValues, Path } from "react-hook-form";

import { selectInputOnFocus } from "#shared/helpers/selectInputOnFocus";
import { SelectInput } from "#shared/view/designSystem/SelectInput";

import {
  BaseSelectInputController,
  BaseSelectInputControllerProps,
} from "./BaseSelectInputController";

export const SelectInputController = <
  T extends FieldValues,
  IP extends Record<string, unknown> = Record<string, unknown>,
>(
  props: Omit<BaseSelectInputControllerProps<T, IP>, "InputComponent"> & {
    name: Path<T>;
    data: ComboboxData;
  },
) => {
  return (
    <BaseSelectInputController<T, IP>
      {...(props as BaseSelectInputControllerProps<T, IP>)}
      InputComponent={SelectInput}
      onFocus={selectInputOnFocus}
    />
  );
};
